export const categories = [
  {
    slug: 'hanman',
    name: '韩漫',
    icon: 'ri-global-line',
    count: 1856,
    description: '韩国漫画，画风精美，剧情丰富',
    color: 'primary',
  },
  {
    slug: 'riman',
    name: '日漫',
    icon: 'ri-earth-line',
    count: 3241,
    description: '日本漫画，经典连载，热血青春',
    color: 'accent',
  },
  {
    slug: 'guoman',
    name: '国漫',
    icon: 'ri-flag-line',
    count: 1523,
    description: '国产漫画，崛起之作，精彩纷呈',
    color: 'secondary',
  },
  {
    slug: 'wanjie',
    name: '已完结',
    icon: 'ri-check-double-line',
    count: 892,
    description: '完结漫画，一口气看到爽',
    color: 'primary',
  },
  {
    slug: 'paihang',
    name: '排行榜',
    icon: 'ri-bar-chart-line',
    count: 100,
    description: '热门排行，大家都在看',
    color: 'accent',
  },
  {
    slug: 'tuijian',
    name: '编辑推荐',
    icon: 'ri-thumb-up-line',
    count: 256,
    description: '编辑精选，品质保障',
    color: 'secondary',
  },
];

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  tags: string[];
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: number;
  updateTime: string;
  latestChapter: string;
}

export const latestComics: Comic[] = [
  {
    id: 1,
    title: '重生之都市仙尊',
    author: '风行天下',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20manhua%20cover%20art%20featuring%20a%20handsome%20male%20protagonist%20with%20flowing%20dark%20hair%20in%20traditional%20Chinese%20cultivation%20robes%2C%20surrounded%20by%20mystical%20golden%20energy%2C%20modern%20city%20skyline%20in%20background%2C%20dramatic%20lighting%2C%20anime%20style%20illustration%20with%20rich%20warm%20orange%20and%20gold%20tones%2C%20dynamic%20composition%2C%20professional%20manga%20cover%20quality&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    category: 'guoman',
    tags: ['玄幻', '修仙', '都市'],
    description: '一代仙尊重生回到都市少年时代，带着前世的记忆与修为，他要在现代都市中重新崛起，踏上巅峰之路。',
    status: '连载中',
    rating: 4.8,
    views: 1256000,
    chapters: 326,
    updateTime: '2026-08-04',
    latestChapter: '第326话 仙尊重临',
  },
  {
    id: 2,
    title: '绝世神医在都市',
    author: '夜听风',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manhua%20cover%20featuring%20a%20young%20handsome%20doctor%20in%20white%20coat%20holding%20silver%20needles%2C%20surrounded%20by%20glowing%20medical%20symbols%2C%20modern%20hospital%20background%20blurred%2C%20anime%20illustration%20style%20with%20clean%20lines%2C%20warm%20coral%20and%20white%20color%20scheme%2C%20professional%20manga%20cover%20art&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    category: 'guoman',
    tags: ['都市', '医术', '逆袭'],
    description: '绝世神医携带逆天医术重生都市，从此妙手回春，权倾天下，各方势力竞相拉拢。',
    status: '连载中',
    rating: 4.6,
    views: 983000,
    chapters: 218,
    updateTime: '2026-08-04',
    latestChapter: '第218话 神医归来',
  },
  {
    id: 3,
    title: '暗夜帝王的情人',
    author: '金秀妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20featuring%20an%20elegant%20woman%20in%20a%20red%20evening%20dress%20and%20a%20mysterious%20man%20in%20a%20black%20suit%2C%20dramatic%20backlighting%2C%20city%20nightscape%2C%20anime%20style%20illustration%2C%20luxurious%20and%20sensual%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20tones&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '都市', '霸总'],
    description: '她只是一个小小的秘书，却意外成为了暗夜帝王的情人，在权力与爱情的漩涡中挣扎。',
    status: '连载中',
    rating: 4.9,
    views: 2150000,
    chapters: 198,
    updateTime: '2026-08-03',
    latestChapter: '第198话 最后的抉择',
  },
  {
    id: 4,
    title: '最强勇士传说',
    author: '田中一郎',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20cover%20featuring%20a%20young%20warrior%20with%20spiky%20hair%20wielding%20a%20massive%20sword%2C%20epic%20fantasy%20battle%20background%20with%20dragons%2C%20anime%20art%20style%20with%20bold%20lines%2C%20vibrant%20orange%20and%20gold%20color%20scheme%2C%20action%20packed%20composition&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    category: 'riman',
    tags: ['冒险', '热血', '奇幻'],
    description: '平凡少年意外获得最强勇士传承，从此踏上冒险之旅，与伙伴们一起对抗黑暗势力。',
    status: '连载中',
    rating: 4.7,
    views: 1870000,
    chapters: 452,
    updateTime: '2026-08-04',
    latestChapter: '第452话 最终决战',
  },
  {
    id: 5,
    title: '女总裁的贴身高手',
    author: '墨香书客',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20manhua%20cover%20featuring%20a%20tough%20bodyguard%20in%20black%20suit%20protecting%20a%20beautiful%20female%20CEO%2C%20modern%20skyscraper%20background%2C%20anime%20illustration%20style%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20coral%20accents%2C%20professional%20comic%20cover%20quality&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    category: 'guoman',
    tags: ['都市', '保镖', '逆袭'],
    description: '退役特种兵成为冰山女总裁的贴身保镖，从此都市风云变幻，各路高手纷纷登场。',
    status: '连载中',
    rating: 4.5,
    views: 1560000,
    chapters: 287,
    updateTime: '2026-08-03',
    latestChapter: '第287话 暗中保护',
  },
  {
    id: 6,
    title: '魔王的契约新娘',
    author: '李恩珠',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20romance%20manhwa%20cover%20featuring%20a%20beautiful%20bride%20with%20long%20flowing%20hair%20in%20a%20white%20wedding%20dress%20and%20a%20dark%20demon%20king%20in%20black%20royal%20attire%2C%20gothic%20castle%20background%2C%20anime%20illustration%20style%2C%20dramatic%20contrast%20with%20warm%20amber%20and%20deep%20shadows&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    category: 'hanman',
    tags: ['奇幻', '恋爱', '契约'],
    description: '为了拯救家族，她不得不与魔王签订契约成为他的新娘，却不知这是一场精心策划的阴谋。',
    status: '连载中',
    rating: 4.8,
    views: 1890000,
    chapters: 165,
    updateTime: '2026-08-04',
    latestChapter: '第165话 魔王的真心',
  },
  {
    id: 7,
    title: '穿越异世界的美食家',
    author: '松本次郎',
    cover: 'https://readdy.ai/api/search-image?query=A%20fun%20Japanese%20manga%20cover%20featuring%20a%20young%20chef%20in%20apron%20holding%20delicious%20food%20in%20a%20fantasy%20medieval%20world%2C%20colorful%20anime%20art%20style%2C%20warm%20golden%20and%20orange%20tones%2C%20playful%20composition%20with%20magical%20ingredients%20floating%20around&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    category: 'riman',
    tags: ['美食', '异世界', '冒险'],
    description: '米其林大厨穿越到异世界，用现代料理征服奇幻大陆，美食与冒险的奇妙之旅。',
    status: '连载中',
    rating: 4.6,
    views: 867000,
    chapters: 134,
    updateTime: '2026-08-02',
    latestChapter: '第134话 龙肉料理',
  },
  {
    id: 8,
    title: '剑道至尊',
    author: '剑走偏锋',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20manhua%20cover%20featuring%20a%20swordsman%20in%20flowing%20white%20robes%20holding%20a%20glowing%20ancient%20sword%2C%20mountainous%20landscape%20with%20cherry%20blossoms%2C%20anime%20illustration%20style%2C%20elegant%20composition%20with%20warm%20coral%20and%20gold%20accents%2C%20martial%20arts%20theme&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    category: 'guoman',
    tags: ['武侠', '修仙', '剑道'],
    description: '少年剑客从小镇出发，手持古剑踏上剑道巅峰之路，一剑破万法，纵横天地间。',
    status: '连载中',
    rating: 4.7,
    views: 1340000,
    chapters: 389,
    updateTime: '2026-08-04',
    latestChapter: '第389话 剑破苍穹',
  },
];

export const hotComics: Comic[] = [
  {
    id: 9,
    title: '霸道总裁的替身新娘',
    author: '韩美妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20drama%20manhwa%20cover%20featuring%20a%20beautiful%20bride%20looking%20sad%20while%20a%20cold%20handsome%20CEO%20stands%20behind%20her%2C%20luxurious%20mansion%20interior%2C%20anime%20illustration%20style%2C%20dramatic%20warm%20amber%20and%20coral%20lighting%2C%20emotional%20atmosphere&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '霸总', '替身'],
    description: '她代替妹妹嫁给冷酷总裁，原以为只是一场交易，却没想到冰山总裁的心正在慢慢融化。',
    status: '已完结',
    rating: 4.9,
    views: 3250000,
    chapters: 200,
    updateTime: '2026-07-28',
    latestChapter: '第200话 幸福结局 [完]',
  },
  {
    id: 10,
    title: '全职猎人：新世界篇',
    author: '山田健太',
    cover: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Japanese%20manga%20cover%20featuring%20a%20young%20hunter%20with%20determined%20eyes%20holding%20a%20weapon%2C%20dark%20continent%20background%20with%20mysterious%20creatures%2C%20anime%20art%20style%2C%20bold%20dynamic%20lines%2C%20warm%20golden%20and%20deep%20orange%20tones&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    category: 'riman',
    tags: ['冒险', '热血', '战斗'],
    description: '猎人们踏上暗黑大陆的冒险，面对前所未有的强敌，友情与信念将受到终极考验。',
    status: '连载中',
    rating: 4.9,
    views: 4560000,
    chapters: 510,
    updateTime: '2026-08-04',
    latestChapter: '第510话 暗黑大陆',
  },
  {
    id: 11,
    title: '斗罗之武魂觉醒',
    author: '唐门弟子',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20cultivation%20manhua%20cover%20featuring%20a%20young%20warrior%20with%20glowing%20martial%20spirit%20behind%20him%2C%20epic%20battlefield%20with%20energy%20effects%2C%20anime%20illustration%20style%2C%20vibrant%20warm%20coral%20and%20gold%20color%20scheme%2C%20dynamic%20action%20pose&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    category: 'guoman',
    tags: ['玄幻', '武魂', '热血'],
    description: '穿越到斗罗世界，觉醒绝世武魂，从此踏上封号斗罗的传奇之路。',
    status: '连载中',
    rating: 4.8,
    views: 2890000,
    chapters: 678,
    updateTime: '2026-08-04',
    latestChapter: '第678话 神级对决',
  },
  {
    id: 12,
    title: '重生之财阀千金',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20manhwa%20cover%20featuring%20an%20elegant%20woman%20in%20designer%20clothes%20with%20confident%20expression%2C%20luxury%20penthouse%20background%2C%20anime%20illustration%20style%2C%20sophisticated%20warm%20golden%20and%20amber%20tones%2C%20fashion%20magazine%20quality&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    category: 'hanman',
    tags: ['重生', '商战', '女强'],
    description: '前世被人陷害而亡，重生回到十年前，这一次她要让所有敌人付出代价，成为顶级财阀。',
    status: '连载中',
    rating: 4.7,
    views: 1780000,
    chapters: 145,
    updateTime: '2026-08-03',
    latestChapter: '第145话 收购计划',
  },
  {
    id: 13,
    title: '篮球少年之全国大赛',
    author: '井上翔太',
    cover: 'https://readdy.ai/api/search-image?query=A%20sports%20manga%20cover%20featuring%20a%20determined%20basketball%20player%20jumping%20for%20a%20dunk%2C%20stadium%20crowd%20background%2C%20anime%20illustration%20style%2C%20dynamic%20motion%20lines%2C%20warm%20orange%20and%20golden%20sports%20lighting&width=400&height=560&seq=manga-cover-13&orientation=portrait',
    category: 'riman',
    tags: ['运动', '篮球', '青春'],
    description: '少年们为了全国大赛的梦想挥洒汗水，在篮球场上书写无悔的青春篇章。',
    status: '已完结',
    rating: 4.8,
    views: 2340000,
    chapters: 310,
    updateTime: '2026-07-15',
    latestChapter: '第310话 最终哨声 [完]',
  },
  {
    id: 14,
    title: '九尾狐传',
    author: '水墨丹青',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20manhua%20cover%20featuring%20a%20nine-tailed%20fox%20spirit%20in%20human%20form%20with%20flowing%20hair%20and%20traditional%20hanfu%2C%20moonlit%20ancient%20Chinese%20palace%20background%2C%20anime%20illustration%20style%2C%20ethereal%20warm%20golden%20and%20coral%20atmosphere&width=400&height=560&seq=manga-cover-14&orientation=portrait',
    category: 'guoman',
    tags: ['玄幻', '仙侠', '妖狐'],
    description: '千年九尾狐化为人形行走人间，在寻找成仙之路的途中，邂逅了一段跨越千年的情缘。',
    status: '连载中',
    rating: 4.6,
    views: 987000,
    chapters: 256,
    updateTime: '2026-08-02',
    latestChapter: '第256话 前世记忆',
  },
  {
    id: 15,
    title: '公主的逆袭之路',
    author: '崔秀英',
    cover: 'https://readdy.ai/api/search-image?query=A%20royal%20romance%20manhwa%20cover%20featuring%20a%20determined%20princess%20in%20elegant%20historical%20gown%20with%20a%20crown%2C%20palace%20throne%20room%20background%2C%20anime%20illustration%20style%2C%20warm%20golden%20and%20amber%20royal%20tones%2C%20dramatic%20lighting&width=400&height=560&seq=manga-cover-15&orientation=portrait',
    category: 'hanman',
    tags: ['宫廷', '逆袭', '女强'],
    description: '被废黜的公主在流放之地积蓄力量，终有一日要重返王都，夺回属于自己的一切。',
    status: '已完结',
    rating: 4.8,
    views: 2670000,
    chapters: 178,
    updateTime: '2026-06-30',
    latestChapter: '第178话 女王加冕 [完]',
  },
  {
    id: 16,
    title: '机甲战神',
    author: '星河战队',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20mecha%20manhua%20cover%20featuring%20a%20giant%20robot%20in%20battle%20pose%20with%20a%20pilot%20in%20cockpit%2C%20sci-fi%20city%20background%2C%20anime%20illustration%20style%2C%20dramatic%20warm%20orange%20and%20golden%20explosion%20effects%2C%20dynamic%20mecha%20design&width=400&height=560&seq=manga-cover-16&orientation=portrait',
    category: 'guoman',
    tags: ['科幻', '机甲', '战斗'],
    description: '未来世界，少年驾驶员与史上最强机甲结缘，为守护人类而战的热血传奇。',
    status: '连载中',
    rating: 4.5,
    views: 756000,
    chapters: 198,
    updateTime: '2026-08-01',
    latestChapter: '第198话 终极机甲',
  },
];

export const heroComics: Comic[] = [
  latestComics[2],
  latestComics[3],
  hotComics[0],
  hotComics[1],
  hotComics[4],
];

export const testimonials = [
  {
    id: 1,
    username: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20young%20boy%20with%20glasses%2C%20simple%20warm%20orange%20background%2C%20friendly%20expression%2C%2C%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '这个网站太棒了！漫画更新速度超快，画质也很清晰，现在每天都要上来看更新。',
    date: '2026-08-03',
  },
  {
    id: 2,
    username: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20avatar%20of%20a%20girl%20with%20long%20black%20hair%2C%20simple%20warm%20golden%20background%2C%20gentle%20smile%2C%2C%20clean%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '分类很清晰，找漫画特别方便。最重要的是没有广告打扰，阅读体验一级棒！',
    date: '2026-08-02',
  },
  {
    id: 3,
    username: '韩漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20anime%20style%20avatar%20of%20a%20trendy%20young%20woman%20with%20wavy%20hair%2C%20simple%20warm%20coral%20background%2C%20happy%20expression%2C%2C%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '韩漫资源非常全，很多其他地方找不到的漫画这里都有，强烈推荐！',
    date: '2026-08-01',
  },
  {
    id: 4,
    username: '热血少年',
    avatar: 'https://readdy.ai/api/search-image?query=A%20energetic%20anime%20style%20avatar%20of%20a%20teenage%20boy%20with%20spiky%20hair%2C%20simple%20warm%20amber%20background%2C%20excited%20expression%2C%2C%20clean%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 4,
    comment: '日漫更新及时，翻译质量也不错。希望可以增加更多经典老漫画资源。',
    date: '2026-07-30',
  },
  {
    id: 5,
    username: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20relaxed%20anime%20style%20avatar%20of%20a%20young%20person%20with%20headphones%2C%20simple%20warm%20orange%20background%2C%20chill%20expression%2C%2C%20clean%20illustration&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    comment: '下拉式阅读体验太好了，躺在床上单手就能看，已经推荐给身边所有朋友了。',
    date: '2026-07-29',
  },
];

export const siteInfo = {
  name: '43423漫画网',
  slogan: '海量免费漫画，随时随地畅享阅读',
  description: '43423漫画网成立于2020年，是国内领先的免费漫画在线阅读平台。我们致力于为广大漫画爱好者提供海量优质漫画资源，涵盖韩漫、日漫、国漫等多种类型，支持下拉式流畅阅读体验。每日更新，让您不错过任何精彩内容。',
  established: '2020年',
  totalComics: '8000+',
  dailyVisitors: '50万+',
  totalChapters: '120万+',
  contact: {
    email: 'contact@43423.com',
    wechat: '漫画网43423',
    qq: '1234567890',
  },
};